export * from './enable-js';

(function () {

  const $password = $('#pw');

  $('.eye').click((e) => {
    $('.eye').toggleClass('hide');
    if ($password.prop('type') === 'password') {
      open();
    } else {
      close();
    }
  });

  function close() {
    $password.prop('type', 'password');
  }

  function open() {
    $password.prop('type', 'text');
  }

})();
